// extracted by mini-css-extract-plugin
export default {"root":"organization_root_HD5h9","full":"organization_full_t0FTd","half":"organization_half_uyhM5","col":"organization_col_Gjb6F"};